<template>
    <p class="headline-register">הרשמה לאתר</p>
    <form action="" @submit.prevent="register" class="customer-register" novalidate>
        <div class="floating-input-wrapper">
            <input v-model="first_name" type="text" name="first_name" class="floating-input" aria-label="שם פרטי" required>
            <span v-bind:class="errors.first_name ? 'label-error floating-label' : 'floating-label'">
                    שם פרטי
                    <span class="required-star">*</span>
                </span>
        </div>
        <div class="floating-input-wrapper">
            <input v-model="last_name" type="text" name="last_name" class="floating-input" aria-label="שם משפחה" required>
            <span v-bind:class="errors.last_name ? 'label-error floating-label' : 'floating-label'">
                    שם משפחה
                    <span class="required-star">*</span>
            </span>
        </div>
        <div class="floating-input-wrapper">
            <input v-model="email" type="text" name="email" class="floating-input" aria-label="אימייל" required>
            <span v-bind:class="errors.email ? 'label-error floating-label' : 'floating-label'">
                    אימייל
                    <span class="required-star">*</span>
            </span>
        </div>
        <div class="error-register" v-if="errors.email">{{errors.email[0]}}</div>
        <div class="floating-input-wrapper">
            <input v-model="phone" type="text" name="phone" class="floating-input" aria-label="טלפון" required>
            <span v-bind:class="errors.phone ? 'label-error floating-label' : 'floating-label'">
                    טלפון
                    <span class="required-star">*</span>
            </span>
        </div>
        <div class="floating-input-wrapper">
            <input v-model="password" type="password" name="password" class="floating-input" aria-label="סיסמה" required>
            <span v-bind:class="errors.phone ? 'label-error floating-label' : 'floating-label'">
                    סיסמה
                    <span class="required-star">*</span>
            </span>
        </div>
        <div class="error-register" v-if="errors.password">{{errors.password[0]}}</div>
        <div class="floating-input-wrapper">
            <input v-model="password_confirmation" type="password" name="password" class="floating-input" aria-label="אימות סיסמה" required>
            <span v-bind:class="errors.password_confirmation ? 'label-error floating-label' : 'floating-label'">
                    אימות סיסמה
                    <span class="required-star">*</span>
            </span>
        </div>
        <span>בחר סוג משתמש:</span>
        <div class="customer-register__radio">
            <div class="form-radio">
                <input v-model="customer_type_id" type="radio" id="test1" value="1" name="radio-group" aria-label="שחקן תחרותי">
                <label for="test1">שחקן תחרותי</label>
            </div>
            <div class="form-radio">
                <input v-model="customer_type_id" type="radio" id="test2" value="2" name="radio-group" aria-label="שחקן חובב">
                <label for="test2" >שחקן חובבן</label>
            </div>
            <div class="form-radio">
                <input v-model="customer_type_id" type="radio" id="test3" value="3" name="radio-group" aria-label="מאמן">
                <label for="test3">מאמן</label>
            </div>
        </div>
        <button type="submit" class="btn-black" aria-label="אישור">אישור</button>
        <a class="go-to-back-register" href="/">חזור לחנות</a>
    </form>
</template>
<style>
    .error-register {
        color: red;
        position: relative;
        top: -25px;
        text-align: right;
        width: 100%;
        font-size: 13px;
    }
</style>
<script>
    import axios from 'axios';

    export default {
        name: 'Register',
        props: {
            modelValue: Object
        },
        computed: {
            personalData() {
                return route('client.policy');
            }
        },
        data() {
            return {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                terms: '',
                customer_type_id: 1,
                errors: []
            }
        },
        mounted() {
        },
        methods: {
            register() {
                axios.post('/customer-register', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    customer_type_id: this.customer_type_id,
                    terms: this.terms,
                })
                    .then((response) => {
                        if(response.data.success) {
                            window.location.reload();
                        }
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors;
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~styles/_mixins.scss";

    .th__user {
        &__modal {
            &__login {
                p {
                    margin-bottom: cvw(36px);
                }
            }
        }
    }
    @include bp(md) {
        .th__user {
            &__modal {
                &__login {
                    p {
                        margin-bottom: cvwt(22px);
                    }

                }
            }
        }
    }
    @include bp(sm) {
        .th__user {
            &__modal {
                &__login {
                    p {
                        margin-bottom: cvm(19px);
                    }

                }
            }
        }
    }
</style>
